import { Form, Input, Checkbox } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './SecondLastNameField.styles';

type Props = {
  nameSecondLastName?: (string | number)[] | string;
  nameHasNoSecondLastName?: (string | number)[] | string;
  labelSecondLastName?: string;
  labelCheckbox?: string;
  placeholderSecondLastName?: string;
  styleSecondLastName?: React.CSSProperties;
  styleCheckbox?: React.CSSProperties;
  disabled?: boolean;
};

//TODO: refactor this component to be more clear

export const SecondLastNameField: React.FC<Props> = ({
  nameSecondLastName = 'secondLastName',
  nameHasNoSecondLastName = 'hasNoSecondLastName',
  labelSecondLastName,
  labelCheckbox,
  placeholderSecondLastName,
  styleSecondLastName,
  styleCheckbox,
  disabled
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const form = Form.useFormInstance();

  const watchedSecondLastName = Form.useWatch(nameSecondLastName, form);
  const hasNosecondLastName = Form.useWatch(nameHasNoSecondLastName, form);

  useEffect(() => {
    if (hasNosecondLastName === undefined && form.isFieldTouched(nameSecondLastName) === false) {
      const hasValue = watchedSecondLastName !== null && watchedSecondLastName !== '';
      form.setFieldValue(nameHasNoSecondLastName, !hasValue);
    }
  }, [
    form,
    hasNosecondLastName,
    nameHasNoSecondLastName,
    nameSecondLastName,
    watchedSecondLastName
  ]);

  useEffect(() => {
    if (form.isFieldTouched(nameHasNoSecondLastName) === false) {
      const hasValue = watchedSecondLastName !== null && watchedSecondLastName !== '';

      if (hasValue && hasNosecondLastName === true) {
        form.setFieldValue(nameHasNoSecondLastName, false);
      } else if (!hasValue && hasNosecondLastName === false) {
        form.setFieldValue(nameHasNoSecondLastName, true);
      }
    }
  }, [watchedSecondLastName, hasNosecondLastName, form, nameHasNoSecondLastName]);

  const handleCheckboxChange = (checked: boolean) => {
    form.setFieldValue(nameHasNoSecondLastName, checked);
    if (checked) {
      form.setFieldValue(nameSecondLastName, null);
    } else {
      form.setFieldValue(nameSecondLastName, '');
    }
  };

  return (
    <Wrapper>
      <Form.Item
        name={nameSecondLastName}
        label={labelSecondLastName || undefined}
        style={{ width: '100%', marginBottom: 0, ...styleSecondLastName }}
        rules={[
          {
            required: true,
            validator(_, value) {
              if (disabled) {
                return Promise.resolve();
              }
              if (hasNosecondLastName) {
                return Promise.resolve();
              }
              if (!value) {
                return Promise.reject(new Error(t('REQUIRED_SECOND_LASTNAME')));
              }
              return Promise.resolve();
            }
          }
        ]}>
        <Input
          disabled={Boolean(disabled) || Boolean(hasNosecondLastName)}
          placeholder={placeholderSecondLastName}
          style={{ width: '100%' }}
        />
      </Form.Item>
      <Form.Item
        name={nameHasNoSecondLastName}
        valuePropName="checked"
        className="second-lastname-checkbox"
        style={styleCheckbox}>
        <Checkbox
          disabled={Boolean(disabled)}
          onChange={e => handleCheckboxChange(e.target.checked)}>
          {labelCheckbox || t('NO_SECOND_LASTNAME')}
        </Checkbox>
      </Form.Item>
    </Wrapper>
  );
};
